import { CountFilterType } from 'modules/queryBuilder/types';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { CountFilterInput } from './CountFilterInput';
import { CountFilterTextWrapper, CountFilterWrapper } from './CountFilter.styles';
import { CountInputKey } from './types';
import { getOnInputChange, getHasCountError } from './utils';
import { MinMaxInputProps } from '../types';
import { COUNT_LIMIT } from './constants';

export const DATA_TEST = {
  inputWrapper: 'min-max-input-wrapper',
};

export const MinMaxInput = ({ countFilterType, value, onChange, ...props }: MinMaxInputProps) => {
  const { t } = useTranslation();
  const onInputChange = getOnInputChange({ value, onChange });
  const minCountError = getHasCountError(value?.minCount);
  const maxCountError = getHasCountError(value?.maxCount, value?.minCount);
  const errorTooltip = t('storybook.tooltips.countLimit', { limit: COUNT_LIMIT });

  if (countFilterType === CountFilterType.ANY) return null;
  return (
    <CountFilterWrapper data-test={DATA_TEST.inputWrapper}>
      <CountFilterInput
        {...props}
        value={value?.minCount ?? null}
        onChange={onInputChange(CountInputKey.Min)}
        placeholder={t('storybook.placeholders.countFilter.min')}
        hasError={minCountError}
        triggerTooltipContent={minCountError ? errorTooltip : undefined}
      />
      {countFilterType === CountFilterType.BETWEEN && (
        <>
          <CountFilterTextWrapper>{'-'}</CountFilterTextWrapper>
          <CountFilterInput
            {...props}
            value={value?.maxCount ?? null}
            onChange={onInputChange(CountInputKey.Max)}
            placeholder={t('storybook.placeholders.countFilter.max')}
            hasError={maxCountError}
            triggerTooltipContent={maxCountError ? errorTooltip : undefined}
          />
        </>
      )}
      <CountFilterTextWrapper>{t('storybook.countFilter.countIndicator')}</CountFilterTextWrapper>
    </CountFilterWrapper>
  );
};
